export default __webpack_public_path__ + "static/media/magnus-carlsen.6634f5be.txt";